import { render, staticRenderFns } from "./receivable_statistics.vue?vue&type=template&id=a5f48d98&scoped=true&"
import script from "./receivable_statistics.vue?vue&type=script&lang=js&"
export * from "./receivable_statistics.vue?vue&type=script&lang=js&"
import style0 from "./receivable_statistics.vue?vue&type=style&index=0&id=a5f48d98&prod&lang=scss&scoped=true&"
import style1 from "./receivable_statistics.vue?vue&type=style&index=1&id=a5f48d98&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5f48d98",
  null
  
)

export default component.exports